import { h } from "@stencil/core";

export const ChevronUp = () => (
    <svg viewBox="0 0 32 32" role="img" fill="currentColor">
        <path d="M10.848 12.8l-5.472 3.264v3.456l0.288-0.16c0.16-0.128 2.592-1.6 5.44-3.296 4.448-2.656 5.216-3.072 5.44-2.976 0.16 0.064 2.624 1.536 5.504 3.264s5.248 3.136 5.28 3.136c0.032 0 0.032-0.768 0.032-1.696l-0.032-1.728-5.088-3.040c-2.784-1.664-5.248-3.136-5.504-3.264l-0.448-0.256-5.44 3.296"></path>
    </svg>
);
